var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 7,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16h16v3H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19v1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19v1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvUnit);
export default __webpack_public_path__ + "static/media/tv-unit.9a2f5c629e7d503fb4cd961da40c49d0.svg";
export { ForwardRef as ReactComponent };